import Article from "@/components/Article";

export default function Articles({articles, park}) {
    return (
        <>
            {articles.map((article) => <Article key={article.id} article={article} /> )}
        </>
    )
}